import { render } from "./wfm-refBy.vue?vue&type=template&id=21fc99b6&scoped=true"
import script from "./wfm-refBy.vue?vue&type=script&lang=js"
export * from "./wfm-refBy.vue?vue&type=script&lang=js"

import "./wfm-refBy.vue?vue&type=style&index=0&id=21fc99b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21fc99b6"]])

export default __exports__